import React from 'react';
import { Route } from 'react-router-dom';

import { ADMIN_INVITATIONS_APP_PATHS } from '../constants/invitations-app-paths.constants';
import AdminInvitationDetailsView from '../views/admin/AdminInvitationDetails.view';
import AdminInvitationsView from '../views/admin/AdminInvitations.view';

export default function AdminInvitationsRoutes() {
  return (
    <React.Fragment>
      <Route
        exact
        path={ADMIN_INVITATIONS_APP_PATHS.INVITATION_DETAILS(':invitationId')}
        component={AdminInvitationDetailsView}
      />
      <Route exact path={ADMIN_INVITATIONS_APP_PATHS.INVITATIONS_LIST} component={AdminInvitationsView} />
    </React.Fragment>
  );
}
